import React from 'react';

const BondCreditQualityComponent = () => {
  const bondCredit="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Roots+and+Wings%2C+3lens+and+LSG/Bond+Security.png";
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row-reverse items-center gap-8">
          {/* Image side (right side in desktop) */}
          <div className="w-full md:w-2/5">
            <img 
              src={bondCredit} 
              alt="Bond Credit Quality" 
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
          
          {/* Content side (left side in desktop) */}
          <div className="w-full md:w-3/5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">Lens 2: Bond Credit Quality</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-4">Focus: Safety of Debt Holdings in Hybrid or Debt-Oriented Funds</h3>
            
            <p className="text-gray-700 mb-4">
              When mutual funds hold bonds, we examine the credit quality of those instruments. 
              We prefer funds with high-grade, less fragile debt structures.
            </p>
            
            <h4 className="font-medium text-[#113262] mb-2">We prioritise:</h4>
            <ul className="mb-4 space-y-2">
              {[
                'AAA-rated sovereign and corporate bonds',
                'Low-default risk instruments',
                'Funds that stay away from structured credit or promoter-backed risky debt'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <p className="text-gray-700">
              This lens ensures that the "safety" part of your mutual fund portfolio is genuinely safe—and not just marketed that way.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BondCreditQualityComponent;